import {
  AccountsApi,
  Configuration,
  type RefreshTokenRequest,
  type RefreshTokenResponse,
} from '@trinnvis/dabih-api-client';

// Refresh-kallet står midt i boot-stien og heartbeaten; en request som aldri
// svarer (mobilnett, proxy som svelger den) må bli en rejection slik at
// cached-token-fallbacken i refreshAccessToken slår inn i stedet for at
// innlastingen henger (#13438).
const REFRESH_TIMEOUT_MS = 15_000;

export async function refreshToken(requestParameters: RefreshTokenRequest): Promise<RefreshTokenResponse> {
  const config = new Configuration({ fetchApi: fetch });
  const api = new AccountsApi(config);

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), REFRESH_TIMEOUT_MS);
  try {
    return await api.refreshToken(requestParameters, { signal: controller.signal });
  } finally {
    clearTimeout(timer);
  }
}
